import { BaseModel } from './base';

export class EventType extends BaseModel {
  EventtypeName: string;
  SubscriberId: string;
  SiteId: string;
  Status: string;
  id: string;
}
